<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="OK()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [modalHelpIndex]="modalHelpIndex"
    [modalDraggable]=true [(isBusyMessage)]="isBusyMessage" [modalClass]="modalClass" [resizeHorizontal]="true"
    [resizeHorizontalMin]="480" [resizeVertical]="true" [resizeVerticalMin]="200">
    <div class="buttonsRow" style="padding-bottom: 10px">
        <button (click)="openFileInput.click()" class="secondary-button" [disabled]="isPrimaryButtonEnabled()">
            <i class="fa fa-folder-open loadFileIcon"></i> Load from File ...
        </button>
        <input id="file-upload" #openFileInput type="file" accept=".txt" (change)="newFileUploaded($event)"
            onclick="this.value=null;" data-automation-id="load-from-file-button" />
        <span class="password-count">Password count:
            <span>{{loadedFromFile ? passwordCount: allEntries.length - 1}}</span></span>
        <button type="button" data-automation-id="clear-all-button" class="secondary-button clear-button"
            (click)="clearAllEntries()" [disabled]="allEntries.length === 1 && !loadedFromFile"
            data-automation-id="clear-all-button">
            <i class="fa fa-trash fa-icon clearButtonIcon"></i>{{clearButtonName}}</button>
    </div>
    <div class="aliasesRow" *ngIf="!loadedFromFile">
        <res-key-value-list [placeholderField1]='"Enter one per line or paste multiple ... "' [rows]="allEntries"
            [queriesChanged]="queriesChanged.bind(this)" [queryColumnHidden]="true" automationId="row-name-label-"
            [validateName]="false" [preserveSpaces]="true">
        </res-key-value-list>
    </div>
    <div *ngIf="loadedFromFile" class="loaded-from-file-div">
        <span class="file-name-span">File:
            <span>{{fileName}}</span></span>
    </div>
</res-base-modal>